document.addEventListener('DOMContentLoaded', function() {
    // Ocultar el formulario inicialmente
    const formWrapper = document.querySelector('.contact-info-hero__form-wrapper');
    if (formWrapper) {
        formWrapper.style.opacity = '0';
        formWrapper.style.transition = 'opacity 0.3s ease-in-out';
    }
    
    function aplicarEstilos() {
        const formEmbed = document.querySelector('.contact-info-hero__form-wrapper shopify-forms-embed');
        
        if (!formEmbed?.shadowRoot) return false;
        const shadowRoot = formEmbed.shadowRoot;
        
        // Verificar si ya se aplicaron los estilos
        if (shadowRoot.querySelector('.estilos-aplicados')) return true;
        
        // Marcar que los estilos ya fueron aplicados
        const marcador = document.createElement('div');
        marcador.className = 'estilos-aplicados';
        marcador.style.display = 'none';
        shadowRoot.appendChild(marcador);
        
        // Crear e inyectar los estilos CSS
        const style = document.createElement('style');
        style.textContent = `
            section._inline_1q1d2_47 ._formContainer_1q1d2_30{ 
              max-width: 100%; 
            }
            ._formFieldset_cit2d_82 div._formFieldContainer_1mxsl_5 {
               flex-direction: column-reverse;
            }
            ._formFieldset_cit2d_82 label._formInputFieldLabel_1mxsl_38,
            ._formFieldset_cit2d_82 p._textBody_2aowh_10 {
                text-transform: uppercase;
                margin-top: 0;
                margin-bottom: 10px;
                color: #830DFF;
                font-family: "ABC Favorit Mono Unlicensed Trial";
                font-size: 20px;
                font-style: normal;
                font-weight: 800;
                line-height: 1.45;
                text-transform: uppercase;
                position: initial;
                max-width: none;
                transform: none !important;
            }
            ._formFieldset_cit2d_82 ._selectToggle_12thd_25 {
                box-sizing: border-box;
                color: #BCBCBC;
                font-family: "ABC Favorit Mono Unlicensed Trial";
                font-size: 18px;
                font-style: normal;
                font-weight: 350;
                line-height: 111%;
                text-transform: uppercase;
                background-color: rgba(112, 112, 112, 0.08);
                border-radius: 5px;
                border: none;
                box-shadow: none;
                padding: 12px 18px;
                max-width: none;
                width: 95%;
            }
            ._formFieldset_cit2d_82 ._selectToggleText_12thd_25 {
                margin-top: 0;
                color: #BCBCBC;
                font-family: "ABC Favorit Mono Unlicensed Trial";
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
            }
            .input-container .contact-info-hero__email-label{ 
              text-transform: uppercase; 
              margin-top: 0;
              margin-bottom: 10px;
              color: #830DFF;
              font-family: "ABC Favorit Mono Unlicensed Trial";
              font-size: 20px;
              font-style: normal;
              font-weight: 800;
              line-height:1.45;
              text-transform: uppercase;
            }
            ._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 textarea,
            input[type="text"]._formInputField_nag3b_7 {
                box-sizing: border-box;
                color: #BCBCBC;
                font-family: "ABC Favorit Mono Unlicensed Trial";
                font-size: 18px;
                font-style: normal;
                font-weight: 350;
                line-height: 111%;
                text-transform: uppercase;
                background-color: rgba(112, 112, 112, 0.08);
                border-radius: 5px;
                border: none;
                box-shadow: none;
                padding: 12px 18px;
                max-width: none;
                width: 95%;
            }
            ._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 textarea {
               height: 124px;
               padding-top: 26px;
            }
            ._formFieldset_cit2d_82 ._textArea_17mgw_1:focus-visible {
                padding: 12px 18px;
            }
            input::placeholder, textarea::placeholder{
                color: #BCBCBC !important;
                font-family: "ABC Favorit Mono Unlicensed Trial" !important;
                font-size: 18px !important;
                font-weight: 350 !important;
                text-transform: uppercase !important;
                opacity: 1 !important;
            }
            .input-container textarea{
              height: 124px !important;
            }
            .file-input-container {
                margin-top: 20px;
            }
            .file-input-container .file-input {
                width: 95% !important;
                box-sizing: border-box;
                color: transparent;
                font-family: "ABC Favorit Mono Unlicensed Trial";
                font-size: 18px;
                font-style: normal;
                font-weight: 350;
                line-height: 111%;
                text-transform: uppercase;
                background-color: rgba(112, 112, 112, 0.08);
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cline x1='6' y1='5.82818e-08' x2='6' y2='12' stroke='%23830DFF' stroke-width='2'/%3E%3Cline x1='12' y1='6' x2='-6.55671e-08' y2='6' stroke='%23830DFF' stroke-width='2'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: right 18px center;
                background-size: 12px 12px;
                border-radius: 5px;
                border: none;
                box-shadow: none;
                padding: 12px 40px 12px 18px;
                cursor: pointer;
            }
            .file-input-container .file-input::file-selector-button {
                display: none;
            }
            button[type="submit"]._formSubmitButton_cit2d_96{
              order: 9;
              color: #FFF;
              background-color: #830DFF;
              font-family: "Helvetica Now Display";
              font-size: 16px;
              font-style: normal;
              font-weight: 800;
              line-height: normal;
              text-transform: uppercase;
              border-radius: 120px;
              height: 48px;
              max-height: 48px;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            ._formFieldContainer_1mxsl_5:has(textarea)::before{
              display: none !important;
            }
            form._formFieldset_cit2d_82{
              gap: 20px !important;
              padding: 0 !important;
            }
            div._gridItemContent_1q1d2_257{
              padding: 0;
            }
            #form-container-ref {
              width: 100% !important;
            }
            ._fadeAnimation_3eyaa_87 {
              display: flex !important;
            }
            ._formFieldset_cit2d_82 ._dropdownContainer_12thd_63 {
              left: 1px;
            }
            ._formFieldset_cit2d_82 ._optionListItem_12thd_102 {
              color: #830DFF;
            }
            @media screen and (max-width: 750px) {
              ._formFieldset_cit2d_82 label._formInputFieldLabel_1mxsl_38, 
              ._formFieldset_cit2d_82 p._textBody_2aowh_10 {
                font-size: 14px;
              }
              section._inline_1q1d2_47 ._formContainer_1q1d2_30{
                min-width: 305px;
              }
            }
            @media screen and (max-width: 374px) {
              section._inline_1q1d2_47 ._formContainer_1q1d2_30{
                min-width: 100%;
              }
            }
            `;
        shadowRoot.appendChild(style);
        
        // Agregar placeholders desde los labels
        const formContainers = shadowRoot.querySelectorAll('._formFieldContainer_1mxsl_5');
        formContainers.forEach(container => {
            const label = container.querySelector('label._formInputFieldLabel_1mxsl_38');
            const input = container.querySelector('input._formInputField_nag3b_7');
            const textarea = container.querySelector('textarea._textArea_17mgw_1');
            
            if (label) {
                const labelText = label.textContent.trim();
                
                if (input && labelText) {
                    input.setAttribute('placeholder', labelText);
                    input.placeholder = labelText;
                }
                
                if (textarea && labelText) {
                    textarea.setAttribute('placeholder', labelText);
                    textarea.placeholder = labelText;
                }
            }
        });
        
        // Mostrar el formulario con transición suave
        if (formWrapper) {
            setTimeout(() => {
                formWrapper.style.opacity = '1';
            }, 50);
        }
        
        return true;
    }
    
    const intervalo = setInterval(() => {
        if (aplicarEstilos()) clearInterval(intervalo);
    }, 500);
});